import { useBranchesStore } from '@/store/BranchesStore';
import { useContextStore } from '@/store/ContextStore';
import { useRouter } from 'vue-router';

export function useRouting() {
  const router = useRouter();
  const branchesStore = useBranchesStore();
  const contextStore = useContextStore();

  function navigateTo(path: string) {
    router.push(path);
  }

  function generatePath(routePath: string) {
    if (contextStore.isShell && contextStore.isMicroFrontend) {
      return `${contextStore.basePath}/${branchesStore.selectedBranchId}/${routePath}`;
    }
    return `/${branchesStore.selectedBranchId}/${routePath}`;
  }

  function getNewPath(resource: string) {
    return generatePath(`${resource}/new`);
  }

  function getEditPath(resource: string, docId: string) {
    const path = `${resource}/config/${docId}`;
    return generatePath(path);
  }

  function getListPath(resource: string) {
    return generatePath(`${resource}/list`);
  }

  function getRoute(routePath: string) {
    return generatePath(routePath);
  }

  function getRouteName(name: string): string {
    return contextStore.isShell ? `l11-waap:${name}` : name;
  }

  function normalizeRouteName(name: string | null | undefined): string {
    if (!name) return '';
    return name.replace(/^l11-waap:/, '');
  }

  return {
    generatePath,
    getNewPath,
    getEditPath,
    getListPath,
    navigateTo,
    getRoute,
    getRouteName,
    normalizeRouteName,
  };
}
